<template>
  <div>
    <el-dialog title="Edit Quotation" :close-on-click-modal="false" :visible.sync="visible" width="1650px" append-to-body top="2vh">
      <el-form :model="dataForm" ref="dataForm" label-width="0" size="mini">
        <div class="wdb100 quotationWrap">
          <el-button
            type="primary"
            size="small"
            plain
            icon="el-icon-plus"
            class="mb10"
            @click="dataForm.contentList.push(JSON.parse(JSON.stringify(contentObj)))"
            v-if="dataForm.contentList.length == 0"
          >
            Add Item
          </el-button>
          <div class="shadeWrap" v-for="(parent, index) in dataForm.contentList" :key="`parent${index}`">
            <!-- Billing to -->
            <el-row :gutter="16" class="pt10 pb16 fxRow borderTop billingTop">
              <el-col :span="1" class="tac">
                <span
                  class="fs18 cursor-pointer blue el-icon-circle-plus-outline"
                  @click="dataForm.contentList.splice(index + 1, 0, JSON.parse(JSON.stringify(contentObj)))"
                ></span>
                <span class="fs18 ml8 cursor-pointer red el-icon-remove-outline" @click="dataForm.contentList.splice(index, 1)"></span>
              </el-col>
              <el-col :span="3" class="flex align-center">
                <span class="billingTo">Client Code:</span>
                <el-form-item :prop="`contentList.${index}.clientCode`" :ref="`contentList.${index}.clientCode`" class="wdb100">
                  <client-code-select-remote-search
                    v-model="parent.clientCode"
                    :showItems="['companyName', 'billingAddresses']"
                    placeholder="Select"
                    class="text-left"
                    @change-item="data => clientCodeChange(data, parent)"
                  ></client-code-select-remote-search>
                </el-form-item>
              </el-col>
              <el-col :span="7" class="flex align-center">
                <span class="billingTo">Billing to:</span>
                <el-form-item
                  :prop="`contentList.${index}.companyTitle`"
                  :ref="`contentList.${index}.companyTitle`"
                  :rules="{
                    required: true,
                    message: 'please enter',
                    trigger: 'submit',
                  }"
                  class="wdb100"
                >
                  <el-input v-model="parent.companyTitle" placeholder="Billing to" class="text-left"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" class="flex align-center">
                <span class="billingTo">Address:</span>
                <el-form-item :prop="`contentList.${index}.companyAddress`" class="wdb100">
                  <el-input v-model="parent.companyAddress" placeholder="Address" class="text-left"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4" class="flex align-center">
                <span class="billingTo">Country:</span>
                <el-form-item :prop="`contentList.${index}.companyCountry`" class="wdb100">
                  <el-select v-model="parent.companyCountry" placeholder="Select" filterable class="wdb100 text-left">
                    <el-option v-for="item in countryList" :key="`country-${index}-${item.value}`" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3" class="flex align-center">
                <span class="billingTo">Code:</span>
                <el-form-item :prop="`contentList.${index}.companyPostalCode`" class="wdb100">
                  <el-input v-model="parent.companyPostalCode" placeholder="Code" class="text-left"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 供应商 -->
            <el-row :gutter="16" class="pt10 pb16 fxRow borderTop billingTop">
              <el-col :span="1"></el-col>
              <el-col :span="7" class="flex align-center">
                <span class="billingTo">Supplier:</span>
                <el-form-item
                  :prop="`contentList.${index}.supplierId`"
                  :ref="`contentList.${index}.supplierId`"
                  :rules="{
                    required: true,
                    message: 'please select',
                    trigger: 'submit',
                  }"
                  class="wdb100"
                >
                  <el-select
                    v-model="parent.supplierId"
                    class="wdb100 tal"
                    @change="
                      () => {
                        parent.invoiceTemplateId = null;
                        parent.bankAccountIds = [];
                      }
                    "
                  >
                    <el-option v-for="item in supplierList" :key="`supplier-${index}-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7" class="flex align-center">
                <span class="billingTo">Invoice Template:</span>
                <el-form-item
                  :prop="`contentList.${index}.invoiceTemplateId`"
                  :rules="{
                    required: true,
                    message: 'please select',
                    trigger: 'submit',
                  }"
                  class="wdb100"
                >
                  <template v-if="parent.supplierId">
                    <el-select
                      v-model="parent.invoiceTemplateId"
                      placeholder="Select Invoice Template"
                      class="wdb100 tal"
                      @change="
                        () => {
                          parent.bankAccountIds = [];
                        }
                      "
                    >
                      <el-option
                        v-for="item in invoiceTemplateOptions(parent)"
                        :key="`invoiceTemplate-${index}-${item.id}`"
                        :label="item.templateName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                  <p class="fs12 black88" v-else>Select supplier first</p>
                </el-form-item>
              </el-col>
              <el-col :span="9" class="flex align-center">
                <span class="billingTo">Bank Accounts:</span>
                <el-form-item
                  :prop="`contentList.${index}.bankAccountIds`"
                  :rules="{
                    type: 'array',
                    required: true,
                    message: 'please select',
                    trigger: 'submit',
                  }"
                  class="wdb100"
                >
                  <template v-if="parent.invoiceTemplateId">
                    <div class="crp fs12" @click="selectBankAccountHandle(parent, index)">
                      <p class="fs12 blue" v-if="parent.bankAccountIds.length > 0">
                        {{ getBankAccountTags(parent) }}
                      </p>
                      <p class="fs12 blue" v-else>Select Bank Account</p>
                    </div>
                  </template>
                  <p class="fs12 black88" v-else>Select invoice template first</p>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 表格标题 -->
            <div class="billingTitle">
              <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
                <el-col :span="1"></el-col>
                <el-col :span="4">
                  <p class="fs12 fwb tac">Fee Schedule</p>
                  <!-- <p class="fs12 fwb tac">收费安排</p> -->
                </el-col>
                <el-col :span="3">
                  <p class="fs12 fwb tac">Covered Period</p>
                  <!-- <p class="fs12 fwb tac">涵盖的服务期间</p> -->
                </el-col>
                <el-col :span="2">
                  <p class="fs12 fwb tac">Amount</p>
                  <!-- <p class="fs12 fwb tac">金额</p> -->
                </el-col>
                <el-col :span="2">
                  <p class="fs12 fwb wbbw tac">Incl. Third Party Fee</p>
                  <!-- <p class="fs12 fwb tac">第三方金额</p> -->
                </el-col>
                <el-col :span="4">
                  <p class="fs12 fwb tac">Note For Third Party</p>
                  <!-- <p class="fs12 fwb tac">第三方费用备注</p> -->
                </el-col>
                <el-col :span="2">
                  <p class="fs12 fwb wbbw tac">Incl. Other Fee</p>
                </el-col>
                <el-col :span="3">
                  <p class="fs12 fwb tac">Note For Other Fee</p>
                </el-col>
                <el-col :span="3">
                  <p class="fs12 fwb tac">Payment Due Date</p>
                  <!-- <p class="fs12 fwb tac">支付到期日</p> -->
                </el-col>
              </el-row>
            </div>

            <!-- 表格内容 -->
            <div class="billingPart" v-for="(sub, idx) in parent.partList" :key="`sub${idx}`">
              <div class="billingContent" v-for="(grand, ids) in sub.itemList" :key="`grand${ids}`">
                <el-row :gutter="10" class="pt10 pb16 fxRow borderTop">
                  <el-col :span="1" class="tac">
                    <span
                      class="fs18 cursor-pointer blue el-icon-circle-plus-outline"
                      @click="sub.itemList.splice(ids + 1, 0, JSON.parse(JSON.stringify(itemObj)))"
                    ></span>
                    <span class="fs18 ml8 cursor-pointer red el-icon-remove-outline" @click="sub.itemList.splice(ids, 1)" v-if="ids != 0"></span>
                  </el-col>
                  <el-col :span="4">
                    <!-- <p class="fs12 tac lh16">{{ grand.title }}</p> -->
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.title`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.title`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-autocomplete
                        v-model="grand.title"
                        :fetch-suggestions="(queryString, cb) => titleQuerySearch(queryString, cb, parent.supplierId)"
                        placeholder="Title Of Charges"
                        class="wdb100"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="flex align-center justify-center">
                    <!-- <p class="fs12 tac lh16">{{ grand.startDate }} ~ {{ grand.endDate }}</p> -->
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.startDate`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.startDate`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-date-picker
                        v-model="grand.startDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="Start Date"
                        class="wd104"
                      ></el-date-picker>
                    </el-form-item>
                    <span class="ml2 mr2">~</span>
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.endDate`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.endDate`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-date-picker v-model="grand.endDate" type="date" value-format="yyyy-MM-dd" placeholder="End Date" class="wd104"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.amount`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.amount`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="grand.amount" v-minusPoint2 placeholder="0.00" class="amountInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.thirdPartyFee`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.thirdPartyFee`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="grand.thirdPartyFee" v-minusPoint2 placeholder="0.00" class="amountInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.noteForThirdParty`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.noteForThirdParty`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-autocomplete
                        v-model="grand.noteForThirdParty"
                        :fetch-suggestions="thirdPartyQuerySearch"
                        placeholder="Note For Third Party"
                        class="wdb100"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.otherFee`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.otherFee`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="grand.otherFee" v-minusPoint2 placeholder="0.00" class="amountInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.itemList.${ids}.noteForOther`"
                      :ref="`contentList.${index}.partList.${idx}.itemList.${ids}.noteForOther`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-autocomplete
                        v-model="grand.noteForOther"
                        :fetch-suggestions="otherQuerySearch"
                        placeholder="Note For Other Fee"
                        class="wdb100"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3"></el-col>
                </el-row>
              </div>

              <!-- 小结 -->
              <div class="billingBrief">
                <el-row :gutter="10" class="pt10 pb16 fxRow borderTop borderBottom">
                  <el-col :span="1" class="tac">
                    <span
                      class="fs18 cursor-pointer blue el-icon-circle-plus-outline"
                      @click="parent.partList.splice(idx + 1, 0, JSON.parse(JSON.stringify(partObj)))"
                    ></span>
                    <span class="fs18 ml8 cursor-pointer red el-icon-remove-outline" @click="parent.partList.splice(idx, 1)" v-if="idx != 0"></span>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.subTotalDesp`"
                      :ref="`contentList.${index}.partList.${idx}.subTotalDesp`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="sub.subTotalDesp" placeholder="Text description of subtotals"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3"></el-col>
                  <el-col :span="2" class="tac">
                    <p class="fs12 lh16 pb2">Subtotal</p>
                    <p class="fs12 fwb lh16 orange newline">{{ currencySymbolFormat(getBillingCurrency(parent)) }}{{ subtotalAmountSum(sub) }}</p>
                  </el-col>
                  <el-col :span="2" class="tac">
                    <p class="fs12 lh16 pb2">Subtotal</p>
                    <p class="fs12 fwb lh16 orange newline">{{ currencySymbolFormat(getBillingCurrency(parent)) }}{{ subTotalThirdPartyFeeSum(sub) }}</p>
                  </el-col>
                  <el-col :span="4"></el-col>
                  <el-col :span="2" class="tac">
                    <p class="fs12 lh16 pb2">Subtotal</p>
                    <p class="fs12 fwb lh16 orange newline">{{ currencySymbolFormat(getBillingCurrency(parent)) }}{{ subTotalOtherFeeSum(sub) }}</p>
                  </el-col>
                  <el-col :span="3" class="fs12 tac">
                    <!-- 是否首期付款 -->
                    <p class="fwb">Is it a down payment?</p>
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.isDownPayment`"
                      :ref="`contentList.${index}.partList.${idx}.isDownPayment`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-radio-group v-model="sub.isDownPayment" @change="sub.paymentDueTime = null">
                        <el-radio :label="1">Yes</el-radio>
                        <el-radio :label="0">No</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <!-- 订单提交时即时支付 -->
                    <p class="fs12 tac lh16" v-if="sub.isDownPayment == 1">Payable upon submission</p>
                    <el-form-item
                      :prop="`contentList.${index}.partList.${idx}.paymentDueTime`"
                      :ref="`contentList.${index}.partList.${idx}.paymentDueTime`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                      v-if="sub.isDownPayment == 0"
                    >
                      <el-date-picker
                        v-model="sub.paymentDueTime"
                        type="date"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="Payment due date"
                        class="wdb100"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 空行占位 -->
                <div class="wdb100 hg40"></div>
              </div>
            </div>

            <!-- 总结 -->
            <div class="billingBottom">
              <el-row :gutter="10" class="pt10 pb10 fxRow borderTop borderBottom">
                <el-col :span="1"></el-col>
                <el-col :span="4">
                  <!-- <p class="fs12 tac lh16">{{ parent.sumTotalDesp }}</p> -->
                  <el-form-item
                    :prop="`contentList.${index}.sumTotalDesp`"
                    :ref="`contentList.${index}.sumTotalDesp`"
                    :rules="{
                      required: true,
                      message: 'please enter',
                      trigger: 'submit',
                    }"
                  >
                    <el-input v-model="parent.sumTotalDesp" placeholder="The literal description of the total"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3"></el-col>
                <el-col :span="2">
                  <p class="fs12 tac lh16 pb2">Total</p>
                  <p class="fs12 tac lh16 fwb orange newline">{{ currencySymbolFormat(getBillingCurrency(parent)) }}{{ sumTotalPriceSum(parent) }}</p>
                </el-col>
                <el-col :span="2">
                  <p class="fs12 tac lh16 pb2">Total</p>
                  <p class="fs12 tac lh16 fwb orange newline">
                    {{ currencySymbolFormat(getBillingCurrency(parent)) }}{{ sumTotalThirdPartyFeeSum(parent) }}
                  </p>
                </el-col>
                <el-col :span="4"></el-col>
                <el-col :span="2">
                  <p class="fs12 tac lh16 pb2">Total</p>
                  <p class="fs12 tac lh16 fwb orange newline">{{ currencySymbolFormat(getBillingCurrency(parent)) }}{{ sumTotalOtherFeeSum(parent) }}</p>
                </el-col>
                <el-col :span="3"></el-col>
                <el-col :span="3"></el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </span>
    </el-dialog>

    <!-- 选择银行账号 - 弹窗 -->
    <select-bank-account ref="selectBankAccountRef" @updateBankAccountIds="updateBankAccountIds" />
  </div>
</template>

<script>
import ClientCodeSelectRemoteSearch from "@/components/SelectRemoteSearch/clientCode";
import SelectBankAccount from "./SelectBankAccount";
import { validateLocation } from "@/utils";
import { addition, toFixedDecimal } from "@/utils/count";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState, mapActions } from "vuex";
export default {
  mixins: [formatterMixin],
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          id: null,
          applymentStatus: "",
          quotationList: [],
        };
      },
    },
    moduleServiceList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    supplierList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    invoiceTemplateList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: { ClientCodeSelectRemoteSearch, SelectBankAccount },
  data() {
    return {
      visible: false,
      dataForm: {
        applymentId: null,
        contentList: [
          {
            clientCode: null,
            companyTitle: null,
            companyAddress: null,
            companyCountry: null,
            companyPostalCode: null,
            sumTotalDesp: null,
            sumTotalPrice: null,
            sumTotalThirdPartyFee: null,
            sumTotalOtherFee: null,
            supplierId: null,
            invoiceTemplateId: null,
            bankAccountIds: [],
            partList: [
              {
                isDownPayment: null,
                subTotalDesp: null,
                subTotalPrice: null,
                subTotalThirdPartyFee: null,
                subTotalOtherFee: null,
                paymentDueTime: null,
                itemList: [
                  {
                    title: null,
                    startDate: null,
                    endDate: null,
                    amount: null,
                    thirdPartyFee: null,
                    noteForThirdParty: null,
                    otherFee: null,
                    noteForOther: null,
                  },
                ],
              },
            ],
          },
        ],
      },
      contentObj: {}, // 备份报价单第一级输入内容项
      partObj: {}, // 备份报价单第二级输入内容项
      itemObj: {}, // 备份报价单第三级输入内容项
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "thirdPartyFeeEnOptions", "otherFeeEnOptions"]),
    // 动态设置发票模板选项
    invoiceTemplateOptions() {
      return data => {
        if (!data) return [];
        if (!data.supplierId) return [];
        // 通过选中的供应商id匹配到对应的发票模板选项
        return this.invoiceTemplateList?.filter(opt => opt.supplierId === data.supplierId) || [];
      };
    },
  },
  methods: {
    ...mapActions("applyment", ["createQuotation", "updateQuotation", "initApplyment"]),
    // 初始化
    async init() {
      this.visible = true;
      this.submitLoading = false;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      const detailCopy = JSON.parse(JSON.stringify(this.detail));
      let contentList = [];
      if (detailCopy.quotationList && detailCopy.quotationList.length > 0) {
        const finalList = [];
        // 清洗数据，设置dataForm.contentList需要的数据
        detailCopy.quotationList.forEach(firstItem => {
          // 第一级
          const firstData = {
            clientCode: firstItem.clientCode,
            companyTitle: firstItem.companyTitle,
            companyAddress: firstItem.companyAddress,
            companyCountry: firstItem.companyCountry,
            companyPostalCode: firstItem.companyPostalCode,
            sumTotalDesp: firstItem.sumTotalDesp,
            sumTotalPrice: firstItem.sumTotalPrice,
            sumTotalThirdPartyFee: firstItem.sumTotalThirdPartyFee,
            sumTotalOtherFee: firstItem.sumTotalOtherFee,
            supplierId: firstItem.supplier?.id || null,
            invoiceTemplateId: firstItem.invoiceTemplate?.id || null,
            bankAccountIds: firstItem.bankAccountList?.map(bank => bank.id) || [],
            partList: [],
          };
          finalList.push(firstData);

          const partList = firstItem?.partList || [];
          partList.forEach(secondItem => {
            // 第二级
            const secondData = {
              isDownPayment: secondItem.isDownPayment,
              subTotalDesp: secondItem.subTotalDesp,
              subTotalPrice: secondItem.subTotalPrice,
              subTotalThirdPartyFee: secondItem.subTotalThirdPartyFee,
              subTotalOtherFee: secondItem.subTotalOtherFee,
              paymentDueTime: secondItem.paymentDueTime,
              itemList: [],
            };
            firstData.partList.push(secondData);

            const itemList = secondItem?.itemList || [];
            itemList.forEach(thirdItem => {
              // 第三级
              const thirdData = {
                title: thirdItem.title,
                startDate: thirdItem.startDate,
                endDate: thirdItem.endDate,
                amount: thirdItem.amount,
                thirdPartyFee: thirdItem.thirdPartyFee,
                noteForThirdParty: thirdItem.noteForThirdParty,
                otherFee: thirdItem.otherFee,
                noteForOther: thirdItem.noteForOther,
              };
              secondData.itemList.push(thirdData);
            });
          });
        });
        contentList = finalList;
      } else {
        // 申请单详情不存在报价列表(quotationList),自动插入一条
        const contentObjCopy = JSON.parse(JSON.stringify(this.contentObj));
        contentList = [contentObjCopy];
      }
      this.dataForm = { applymentId: detailCopy.id, contentList };
    },
    // 合计总额
    sumTotalPriceSum(data) {
      let partSum = 0;
      for (let i in data.partList) {
        partSum = addition(partSum, parseFloat(data.partList[i].subTotalPrice || 0));
      }
      data.sumTotalPrice = partSum;
      return data.sumTotalPrice;
    },
    // 第三方金额 - 合计
    sumTotalThirdPartyFeeSum(data) {
      let tpfSum = 0;
      for (let i in data.partList) {
        tpfSum = addition(tpfSum, parseFloat(data.partList[i].subTotalThirdPartyFee || 0));
      }
      data.sumTotalThirdPartyFee = tpfSum;
      return data.sumTotalThirdPartyFee;
    },
    // 其他费用金额 - 合计
    sumTotalOtherFeeSum(data) {
      let tpfSum = 0;
      for (let i in data.partList) {
        tpfSum = addition(tpfSum, parseFloat(data.partList[i].subTotalOtherFee || 0));
      }
      data.sumTotalOtherFee = tpfSum;
      return data.sumTotalOtherFee;
    },
    // 小计总额
    subtotalAmountSum(item) {
      let subAmoCount = 0;
      for (let i in item.itemList) {
        subAmoCount = addition(subAmoCount, parseFloat(item.itemList[i].amount || 0));
      }
      item.subTotalPrice = toFixedDecimal(subAmoCount);
      return item.subTotalPrice;
    },
    // 第三方金额 - 小计
    subTotalThirdPartyFeeSum(item) {
      let subTpfCount = 0;
      for (let i in item.itemList) {
        subTpfCount = addition(subTpfCount, parseFloat(item.itemList[i].thirdPartyFee || 0));
      }
      item.subTotalThirdPartyFee = toFixedDecimal(subTpfCount);
      return item.subTotalThirdPartyFee;
    },
    // 其他费用 - 小计
    subTotalOtherFeeSum(item) {
      let subTpfCount = 0;
      for (let i in item.itemList) {
        subTpfCount = addition(subTpfCount, parseFloat(item.itemList[i].otherFee || 0));
      }
      item.subTotalOtherFee = toFixedDecimal(subTpfCount);
      return item.subTotalOtherFee;
    },
    // 服务名称模糊查询
    titleQuerySearch(queryString, cb, supplierId) {
      let moduleServiceList = this.moduleServiceList;
      // 如果 supplierId 已选中，则按供应商过滤；未选中则返回所有
      if (supplierId) {
        moduleServiceList = moduleServiceList.filter(item => item.supplier?.id == supplierId);
      }
      let results = queryString ? moduleServiceList.filter(this.createFilter(queryString)) : moduleServiceList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1;
      };
    },
    // 第三方费用描述模糊查询
    thirdPartyQuerySearch(queryString, cb) {
      const thirdPartyFeeEnOptions = this.thirdPartyFeeEnOptions;
      let results = queryString ? thirdPartyFeeEnOptions.filter(this.createFilter(queryString)) : thirdPartyFeeEnOptions;
      cb(results);
    },
    // 其他费用描述模糊查询
    otherQuerySearch(queryString, cb) {
      const otherFeeEnOptions = this.otherFeeEnOptions;
      let results = queryString ? otherFeeEnOptions.filter(this.createFilter(queryString)) : otherFeeEnOptions;
      cb(results);
    },
    // 表单提交
    dataFormSubmit() {
      if (!this.dataForm.contentList || this.dataForm.contentList.length == 0) {
        this.$message.warning("please add item");
        return false;
      }
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          try {
            this.submitLoading = true;
            if (!this.detail.quotationList || this.detail.quotationList.length == 0) {
              // 创建
              await this.createQuotation(this.dataForm);
            } else {
              // 更新
              await this.updateQuotation(this.dataForm);
            }
            // 更新申请详情
            await this.initApplyment(this.dataForm.applymentId);
            this.$message({
              message: "success",
              type: "success",
              duration: 1000,
              onClose: () => {
                this.$emit("updateFeeLetterSomeData");
                this.visible = false;
              },
            });
          } catch (msg) {
            this.submitLoading = false;
          }
        } else {
          validateLocation(object, this);
          return false;
        }
      });
    },
    // Client Code 选中时自动填充对应信息
    clientCodeChange(data, parent) {
      if (!data) return;
      parent.companyTitle = data.companyName || "";
      const billingInfoItem = data.billingInfoItem || {};
      parent.companyAddress = billingInfoItem.billingAddress || "";
      parent.companyCountry = billingInfoItem.billingCountry || "";
      parent.companyPostalCode = billingInfoItem.billingPostalCode || "";
    },
    // 选择银行账户
    selectBankAccountHandle(data, index) {
      const { bankAccountIds, invoiceTemplateId } = data;
      // 获取选中发票模板下的银行账号列表
      const invoiceTemplateBankAccountList = this.invoiceTemplateList?.find(item => item.id == invoiceTemplateId)?.bankAccountList || [];
      // 选择银行账户弹窗-初始化
      this.$refs.selectBankAccountRef.init(bankAccountIds, invoiceTemplateBankAccountList, index);
    },
    // 更新银行账户列表
    updateBankAccountIds(ids, index) {
      const targetPart = this.dataForm.contentList[index];
      this.$set(targetPart, "bankAccountIds", ids);
    },
    // 根据银行账户id获取银行账户tag
    getBankAccountTags(data) {
      const { bankAccountIds, invoiceTemplateId } = data;
      if (bankAccountIds?.length > 0) {
        // 获取选中发票模板下的银行账号列表
        const invoiceTemplateBankAccountList = this.invoiceTemplateList?.find(item => item.id == invoiceTemplateId)?.bankAccountList || [];
        // 以 bankAccountIds 为基准进行 map，确保顺序一致
        const tagList = bankAccountIds
          .map(id => {
            // 在列表中查找对应的账号信息
            const account = invoiceTemplateBankAccountList.find(item => item.id == id);
            return account ? account.tag : null;
          })
          .filter(tag => tag !== null); // 过滤掉无效的 tag
        return tagList.join(", ");
      } else {
        return "";
      }
    },
    // 根据选中的第一个银行id作为开票币种
    getBillingCurrency(data) {
      const { bankAccountIds, invoiceTemplateId } = data;
      if (!bankAccountIds || bankAccountIds?.length == 0) return "";
      // 获取选中发票模板下的银行账号列表
      const invoiceTemplateBankAccountList = this.invoiceTemplateList?.find(item => item.id == invoiceTemplateId)?.bankAccountList || [];
      // 通过选中的第一个银行账户id，来获取开票币种
      const firstId = bankAccountIds[0];
      const currency = invoiceTemplateBankAccountList.find(item => item.id == firstId)?.billingCurrency;
      return currency || "";
    },
    // 自动插入数据(由父组件触发)
    async autoInsertData(data) {
      const result = {
        clientCode: null,
        companyTitle: data?.fqSettings?.customerName || "",
        companyAddress: null,
        companyCountry: null,
        companyPostalCode: null,
        sumTotalDesp: null,
        sumTotalPrice: null,
        sumTotalThirdPartyFee: null,
        sumTotalOtherFee: null,
        supplierId: null,
        invoiceTemplateId: null,
        bankAccountIds: [],
        partList: [],
      };
      let currentPart = null;
      const fqRows = data?.fqRows || [];
      fqRows.forEach(item => {
        // 父级
        if (item.type === "major") {
          currentPart = {
            isDownPayment: null,
            subTotalDesp: `${item.content || ""} ${item.contentZh || ""}`,
            subTotalPrice: item.refAmt || null,
            subTotalThirdPartyFee: null,
            subTotalOtherFee: null,
            paymentDueTime: null,
            itemList: [],
          };

          result.partList.push(currentPart);
          return;
        }
        // 子级
        if (item.type === "sub") {
          // 防止出现没有父级的情况
          if (!currentPart) return;
          currentPart.itemList.push({
            title: `${item.content || ""} ${item.contentZh || ""}`,
            startDate: null,
            endDate: null,
            amount: item.refAmt || null,
            thirdPartyFee: null,
            noteForThirdParty: null,
            otherFee: null,
            noteForOther: null,
          });
        }
      });
      // 兜底：模板的新增按钮在循环内部且首行不可删除，partList / itemList 必须至少保留一条默认数据
      if (result.partList.length === 0) {
        result.partList.push(JSON.parse(JSON.stringify(this.partObj)));
      }
      result.partList.forEach(part => {
        if (!part.itemList || part.itemList.length === 0) {
          part.itemList = [JSON.parse(JSON.stringify(this.itemObj))];
        }
      });
      if (!this.visible) {
        await this.init();
      }
      this.dataForm.contentList.push(result);
    },
  },
  created() {
    // 备份原始数据，用于新增
    const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
    this.contentObj = dataFormCopy.contentList[0];
    this.partObj = this.contentObj.partList[0];
    this.itemObj = this.partObj.itemList[0];
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.billingTo {
  margin-right: 10px;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
}

.quotationWrap {
  ::v-deep {
    .el-form-item {
      margin-bottom: 0px;
    }

    .el-form-item__content {
      line-height: 24px;
    }

    .el-form-item__error {
      padding-top: 0px !important;
      text-align: center;
      width: 100%;
    }

    .billingTop {
      .el-form-item__error {
        text-align: left;
      }
    }

    .el-input__inner {
      font-size: 12px;
      padding-left: 10px;
      padding-right: 20px;
      border: none;
      height: 24px;
      line-height: 24px;
      background: #fdf6ec;
      text-align: center;
    }

    .amountInput {
      .el-input__inner {
        padding-right: 10px;
      }
    }

    .text-left {
      .el-input__inner {
        text-align: left;
      }
    }

    .el-input__prefix {
      display: none;
    }

    .el-input__suffix {
      right: 0px;
    }

    .el-input__icon {
      line-height: 22px;
    }

    .el-radio__label {
      font-size: 12px;
    }
  }
}

p {
  line-height: 16px;
  margin: 0;
  color: #011a45;
}

.shadeWrap {
  width: 100%;
  padding: 0 5px;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  background-color: #fdf6ec;
  margin-bottom: 20px;
}

.shadeWrap:last-child {
  margin-bottom: 10px;
}

.borderTop {
  border-top: 1px solid #e4e7ed;
}

.borderBottom {
  border-bottom: 1px solid #e4e7ed;
}
</style>
